import type { AchievementType } from "@rosette/ts/business/achievement/AchievementType.js";
import { getAchievementIcon } from "@/components/icon/getAchievementIcon.js";
import type { ToastOptions } from "@rosette/web_components/feedback/toast/ToastContext.js";
import type { AchievementResources } from "@/components/achievements/AchievementResources.js";
import Image from "next/image";

export function addAchievementToast(
    achievement: AchievementType,
    addToast: (toast: ToastOptions) => void,
    achievementResources: AchievementResources,
): void {
    addToast({
        type: "achievement",
        title: "New Achievement!",
        message: achievement.getDisplayName(),
        description: achievement.getDesc(),
        icon: (
            <Image
                src={getAchievementIcon(achievement)}
                alt={achievement.getDisplayName()} />
        ),
        includeBorder: true,
        onVisible: () => {
            achievementResources.getEarnedAchievementSound().play(true);
            console.log("play achievement earned sound");
        },
    });
}
